import { useState } from 'react';
import { Range, RangeKeyDict } from 'react-date-range';

import Button from '@components/button/Button';
import Calendar from '@components/calendar/Calendar';
import Icon from '@components/icon/Icon';
import Modal from '@layouts/modal/Modal';
import { formatISODate } from '@utils/date';

interface CalendarModalProps {
  handleDateChange: (data: RangeKeyDict) => void;
  selectedDate: Range;
}

const CalendarModal = ({
  handleDateChange,
  selectedDate
}: CalendarModalProps) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState<Range>({
    startDate: selectedDate.startDate || new Date(),
    endDate: selectedDate.endDate || new Date(),
    key: 'selection'
  });

  const handleChange = (data: RangeKeyDict) => {
    setSelectedDates(data.selection);
  };

  const handleCancel = () => {
    setIsCalendarOpen(false);
  };

  const handleApply = () => {
    setIsCalendarOpen(false);
    const selectedDatesKeyDict = {
      selection: selectedDates
    };
    handleDateChange(selectedDatesKeyDict);
  };

  return (
    <div className="relative ml-2 mt-2">
      <div
        className="flex cursor-pointer items-center gap-2 rounded-lg border bg-grey10 p-4"
        onClick={() => setIsCalendarOpen(true)}
        role="presentation"
      >
        <Icon name="calendar" />
        <div className="text-sm font-medium">
          {selectedDate
            ? `${formatISODate({
                date: selectedDate.startDate || new Date(),
                format: 'DD MMM YYYY'
              })} - ${formatISODate({
                date: selectedDate.endDate || new Date(),
                format: 'DD MMM YYYY'
              })}`
            : 'Select Date Range'}
        </div>
      </div>
      {isCalendarOpen && (
        <Modal isOpen={isCalendarOpen} onCancel={handleCancel}>
          <div className="rounded-lg bg-white shadow-md">
            <Calendar
              handleChange={handleChange}
              startDate={selectedDates.startDate}
              endDate={selectedDates.endDate}
              maxDate={new Date()}
              className="!rounded-t-lg !bg-white"
            />
            <div className="mt-4 flex justify-between gap-2 border-t pt-4">
              <Button
                label="Cancel"
                variant="transparent"
                labelStyle="!text-content"
                handleClick={handleCancel}
              />
              <Button
                label="Apply"
                variant="transparent"
                labelStyle="!text-primary"
                handleClick={handleApply}
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CalendarModal;
